import { render } from "./NewUnit.vue?vue&type=template&id=343045a9&scoped=true"
import script from "./NewUnit.vue?vue&type=script&lang=js"
export * from "./NewUnit.vue?vue&type=script&lang=js"

import "./NewUnit.vue?vue&type=style&index=0&id=343045a9&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343045a9"]])

export default __exports__